var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-loader-container"},[_c('div',{staticClass:"loader-content"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#f46523","size":"64","width":"6"}}),(_vm.message)?_c('p',{staticClass:"loader-message mt-4"},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }